import {
    useTrackOnboardingStep,
    useTrackOnboardingCompleted,
} from "~utils/event-tracking/event-tracking"
import type { EventName } from "~utils/event-tracking/event-tracking-constants"
import { useCreateGenericEvent } from "~utils/hooks/use-create-generic-event"

export function useLogSelfOnboardingEvent({
    stepStartedEventType,
    stepCompletedEventType,
    onboardingCompletedEventType,
}: {
    stepStartedEventType: EventName
    stepCompletedEventType: EventName
    onboardingCompletedEventType: EventName
}) {
    const { createGenericEvent, isLoading } = useCreateGenericEvent()
    const trackOnboardingStepStarted =
        useTrackOnboardingStep(stepStartedEventType)
    const trackOnboardingStepCompleted = useTrackOnboardingStep(
        stepCompletedEventType
    )
    const trackSelfOnboardingCompleted = useTrackOnboardingCompleted(
        onboardingCompletedEventType
    )

    const logStepStarted = (step: string) => {
        trackOnboardingStepStarted(step)
        createGenericEvent({
            eventType: stepStartedEventType,
            metadata: { step },
        })
    }

    const logStepCompleted = (step: string) => {
        trackOnboardingStepCompleted(step)
        createGenericEvent({
            eventType: stepCompletedEventType,
            metadata: { step },
        })
    }

    const logSelfOnboardingCompleted = () => {
        trackSelfOnboardingCompleted()
        createGenericEvent({ eventType: onboardingCompletedEventType })
    }

    return {
        logStepStarted,
        logStepCompleted,
        logSelfOnboardingCompleted,
        isLoading,
    }
}
